@if (value()) {
  <div class="grid-icon-container-values">
    @for (val of value(); track $index) {
      <div class="grid-icon-container-values-value">
        {{ val }}
        @if ($index === 0) {
          <mat-icon [svgIcon]="icon()" class="grid-icon-container-icon"></mat-icon>
        }
      </div>
    }
  </div>
}
